import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Container, CircularProgress } from "@mui/material";
import IndexCard from "../../../shared/IndexCard";
import { Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const ProjectListPage = ({ csrfToken }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const openProjects = projects;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchProjects = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch("/projects.json", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!res.ok) {
        const text = await res.text();
        console.error("projects.json error", res.status, text);
        if (res.status === 403) {
          setProjects([]);
        } else {
          setProjects([]);
        }
        return;
      }
      const data = await res.json();
      setProjects(data);
    } catch (err) {
      console.error("fetchProjects failed:", err);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  }, []);
  
  useEffect(() => {
    fetchProjects();
    const onFocus = () => fetchProjects();
    const onVisibility = () => document.visibilityState === "visible" && fetchProjects();
    const onPageShow = (e) => e.persisted && fetchProjects();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [fetchProjects]);

  const handleMarkedRead = useCallback((projectId) => {
    setProjects((prev) =>
      prev.map((p) => (p.id === projectId ? {...p, read_flag: true} : p))
    );
  }, []);

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 4, mb: 10 }}>
        {/* 左：戻るリンク */}
        <Typography
          mb={3}
          sx={{
            fontSize: "1.25rem",
            fontWeight: "bold",
            textDecoration: "none",
            color: "inherit",
            cursor: "pointer",
            "&:hover": {
              opacity: 0.7,
            },
          }}
          onClick={() => (window.location.href = "/user_contract_request")}
        >
          ＜ 戻る
        </Typography>

        <Typography variant="h5" fontWeight="bold" mb={1}>
          プロジェクト
        </Typography>
        <Typography
          color="text.secondary"
          variant={isMobile ? "caption" : "body2"}
          sx={
            isMobile
              ? { fontSize: "0.82rem", mb: 3, display: "block" }
              : { mb: 3, display: "block" }
          }
        >
          詳細を聞きたいボタンで企業に問い合わせできます
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : openProjects.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            現在、公開中のプロジェクトはありません。
          </Typography>
        ) : (
          openProjects.map((project) => (
            <IndexCard
              key={project.id}
              item={project}
              type="project"
              component={Link}
              to={`/projects/${project.id}`} // ユーザー向け詳細ページへ
              csrfToken={csrfToken}
              onMarkedRead={handleMarkedRead}
            />
          ))
        )}
      </Container>
    </>
  );
};

export default ProjectListPage;
